<p-toast position="top-right" />
<router-outlet />
